<template>
  <div>
    <OssUpload v-bind="$_attrs" v-on="$listeners">
      <el-button v-if="!$_attrs.disabled" size="medium"> <i class="el-icon-upload2"></i>点击上传 </el-button>
    </OssUpload>
  </div>
</template>

<script>
import OssUpload from '../OssUpload'

export default {
  inheritAttrs: false,
  name: 'OssFileUpload',
  components: { OssUpload },
  data() {
    return {
      currUrl: ''
    }
  },
  computed: {
    $_attrs() {
      const { disabled, type, listType } = this.$attrs
      return {
        'list-type': listType ? listType : 'text',
        'on-preview': this.preview,
        'on-exceed': this.exceed,
        multiple: true,
        'show-file-list': true,
        ...this.$attrs,
        disabled: disabled === '' ? true : disabled,
        'before-upload': this.beforeUpload
      }
    }
  },
  methods: {
    preview({ url }) {
      window.open(url)
    },
    beforeUpload(file) {
      const { size } = file
      const isLt100M = size / 1024 / 1024 <= 5
      let flag = true
      if (this.$_attrs.accept) {
        var index = file.name.lastIndexOf('.')
        var ext = file.name.substr(index).toLowerCase()
        var extarr = this.$_attrs.accept.split(',')
        if (extarr.findIndex((n) => n.replace(' ', '') == ext) == -1) {
          flag = false
          this.$message.error('附件格式错误!')
        }
      }
      if (!isLt100M) {
        this.$notify({
          type: 'warning',
          title: '提示',
          message: '文件大小不能超过5M！'
        })
        flag = false
      }
      return flag
    },
    exceed() {
      let { limit } = this.$attrs
      if (limit) {
        this.$message({
          message: `最多上传${limit}个附件！`,
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.el-button {
  width: 135px;
  height: 40px;
  line-height: 40px;
  border: 1px solid $--color-primary;
  border-radius: 8px;
  background-color: #ffffff;
  color: $--color-primary;
  font-size: 16px;
  text-align: center;
  padding: 0;
  i {
    font-size: 16px;
    font-weight: 600;
    margin-right: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OssFileUpload/index.vue